{
  "version": 1,
  "asset_id": "5bad986b-d26b-4e55-ab6c-7e037e2ae97f",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/5bad986b-d26b-4e55-ab6c-7e037e2ae97f/accessories-hero.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/5bad986b-d26b-4e55-ab6c-7e037e2ae97f/accessories-hero.webp",
  "original_filename": "accessories-hero.webp",
  "size": 204712,
  "content_type": "image/webp",
  "created_at": "2026-06-27T00:29:53Z"
}
